import i18n from "../components/shared/i18next"; // Import the configured i18n instance

export const getTLang = () => {
  const currentLang = localStorage.getItem("userLang");
  const getLangCode = (lang) => {
    switch (lang) {
      case "English":
        return "en";
      case "Hindi":
        return "hi";
      case "Marathi":
        return "mar";
      default:
        return "en";
    }
  };

  const langId = getLangCode(currentLang);
  const tForLang = i18n.getFixedT(langId);
  return tForLang;
};

export const formatVideoTime = (currentVideoTime,isReturnInt=false) => {
  const currentTime = currentVideoTime;
  const totalSeconds = Math.floor(currentTime);
  const minutes = Math.floor(totalSeconds / 60);
  const remainingSeconds = totalSeconds % 60;
  const formattedMinutes = minutes.toString().padStart(2, "0");
  const formattedSeconds = remainingSeconds.toString().padStart(2, "0");
  if(isReturnInt){
    return `${formattedMinutes}${formattedSeconds}`
  }
  return `${formattedMinutes}:${formattedSeconds}`;
};


// export const convertTimeStringsToSeconds = (timeStrings) => {
//   return timeStrings.map((timeStr) => {
//     const parts = timeStr.split(":").map(Number);
//     if (parts.length === 2) {
//       const [minutes, seconds] = parts;
//       return minutes * 60 + seconds;
//     } else if (parts.length === 3) {
//       const [hours, minutes, seconds] = parts;
//       return hours * 3600 + minutes * 60 + seconds;
//     }
//     return 0; // fallback
//   });
// };

export const convertTimeStringsToSeconds = (timeStrings) => {
  if (!Array.isArray(timeStrings)) return [];

  return timeStrings.map((timeStr) => {
    if (typeof timeStr !== 'string') return 0;

    const parts = timeStr.split(":").map(Number);

    if (parts.length === 2) {
      const [minutes, seconds] = parts;
      return minutes * 60 + seconds;
    } else if (parts.length === 3) {
      const [hours, minutes, seconds] = parts;
      return hours * 3600 + minutes * 60 + seconds;
    }

    return 0; // fallback
  });
};
